// Excel serial date -> "yyyy-MM-dd"
export const excelSerialToIsoDate = (n) => {
  const base = new Date(Date.UTC(1899, 11, 30));
  const ms = Math.round(Number(n) * 86400000);
  const d = new Date(base.getTime() + ms);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
// "10:00", "14:00:00", "2:10", 0.5 -> "HH:mm:ss"
export const excelFractionToHms = (f) => {
  const totalSec = Math.round(Number(f) * 86400);
  const H = String(Math.floor(totalSec / 3600)).padStart(2, '0');
  const M = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
  const S = String(totalSec % 60).padStart(2, '0');
  return `${H}:${M}:${S}`;
};
// export const toHmsFromCell = (v) => {
//   if (v == null) return '';
//   const s = String(v).trim();
//   if (/^\d+(\.\d+)?$/.test(s)) return excelFractionToHms(s);     // fracción Excel
//   const parts = s.split(':');
//   if (parts.length >= 2) {
//     const H = parts[0].padStart(2, '0');
//     const M = parts[1].padStart(2, '0');
//     const S = (parts[2] ?? '00').padStart(2, '0');
//     return `${H}:${M}:${S}`;
//   }
//   return s;
// };

export function fixIsoDateFromCell(v) {
  if (v == null) return "";
  const s = String(v).trim();
  // número serial Excel
  if (/^\d+(\.\d+)?$/.test(s)) {
    const base = new Date(Date.UTC(1899, 11, 30));
    const ms = Math.round(Number(s) * 86400000);
    const d = new Date(base.getTime() + ms);
    const y = d.getUTCFullYear();
    const mo = String(d.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(d.getUTCDate()).padStart(2, "0");
    return `${y}-${mo}-${dd}`;            // <-- AÑO-MES-DÍA
  }
  // D/M/Y o D-M-Y
  const m = s.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{2,4})$/);
  if (m) {
    let [, dd, mo, y] = m;
    if (y.length === 2) y = String(2000 + Number(y));
    return `${y.padStart(4, "0")}-${String(mo).padStart(2, "0")}-${String(dd).padStart(2, "0")}`; // <-- AÑO-MES-DÍA
  }
  // ya ISO o parseable
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) {
    const y = dt.getFullYear();
    const mo = String(dt.getMonth() + 1).padStart(2, "0");
    const dd = String(dt.getDate()).padStart(2, "0");
    return `${y}-${mo}-${dd}`;
  }
  return s;
}

export function fixHmsFromCell(v) {
  if (v == null) return '';
  const s = String(v).trim();
  if (/^\d+(\.\d+)?$/.test(s)) return excelFractionToHms(s);            // fracción Excel
  const p = s.split(':');
  if (p.length >= 2) {
    const H = p[0].padStart(2, '0'), M = p[1].padStart(2, '0'), S = (p[2] ?? '00').padStart(2, '0');
    return `${H}:${M}:${S}`;
  }
  return s;
}

// Trunca a minuto (hh:mm:00)
const floorToMinute = (s) => {
  const d = new Date(s);
  d.setSeconds(0, 0);
  return d.getTime();
};

// Diferencia en minutos basada en lo que muestras (HH:mm)
export const minutesDiffDisplay = (start, end) => {
  if (!start || !end) return '';
  const a = floorToMinute(start);
  const b = floorToMinute(end);
  const diff = (b - a) / 60000;     // ya es un entero
  return diff > 0 ? diff : 0;
};